import View from "../common/views/SearchSideAdvertising";
import components from "./components.js";
components.define("js-SearchSideAdvertising", View);